import { fetchRemindPassword } from '../repositories/users/v1/remind-password';
export function remind(httpApi, parameters) {
  return fetchRemindPassword({
    httpApi: httpApi,
    parameters: parameters,
    config: {
      requestConfig: {
        headers: [['Content-Type', 'application/json']]
      }
    }
  });
}